<template>
  <App />
</template>

<script>
import App from "./App.vue";
import { provideAuth0 } from "./auth/auth0-plugin";

export default {
  name: "Shell",
  components: { App },
  setup() {
    provideAuth0();
  },
};
</script>
